


import { Component, Vue, Emit } from 'vue-property-decorator';
import { FormFieldData, FormFieldType } from '@/components/FormField/formfield.models';
import FormField from '@/components/FormField/index.vue';
import { Validators, validate } from '@/utils/helpers/validation';

@Component({
  components: { FormField }
})
export default class ExistingCodeInput extends Vue {
  private configCode: FormFieldData = {
    required: true,
    value: '',
    type: FormFieldType.Text,
    hasError: false,
    autocompleteTag: 'configCode',
    validators: [Validators.minLength(9), Validators.maxLength(9)],
    tabbable: true,
    maxlength: 9
  };

  @Emit('focus')
  private handleFocus() {
    return;
  }

  private submitCode() {
    if (validate(this.configCode)) {
      this.$emit('submit-code', this.configCode.value);
    } else {
      this.$emit('validation-error');
    }
  }
}
